module.exports = __webpack_public_path__ + "img/home.ee8dc1bb.svg";